export default function StaticSettingMethodPage() {
  return <div>StaticSettingMethodPage</div>;
}
